import React from 'react';
import { func,array,string } from 'prop-types';
import DragAndDropEventHandler from './DragAndDropEventHandler';
import AnswerCandidateListItem from '../AnswerCandidateListItem/index';
import DraggableItem from '../../atoms/DraggableItem/index';

const DraggableAnswerCandidateListItem = DraggableItem(AnswerCandidateListItem);


const AnswerCandidateList = ({values, onSort, onDelete, answer})=>{
	const lists = <DragAndDropEventHandler 
		key={values}
		values={values}
		onSort={onSort}
		render={({
			value,
			index,
			...props})=>{
			return (<DraggableAnswerCandidateListItem 
				key={value} 
				index={index}
				isAnswer={answer===value}
				onDelete={()=>onDelete(index)}
				{...props} >{value}</DraggableAnswerCandidateListItem>);
		}}
	/>;
	return lists;
};

AnswerCandidateList.propTypes = {
	values : array,
	answer : string,
	onSort : func,
	onDelete : func,
};

export default AnswerCandidateList;